import { render, staticRenderFns } from "./ShouyeWork.vue?vue&type=template&id=3a30ac6a&scoped=true&"
import script from "./ShouyeWork.vue?vue&type=script&lang=js&"
export * from "./ShouyeWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a30ac6a",
  null
  
)

export default component.exports